import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout';
import Home from './pages/Home';
import Services from './pages/Services';
import HomeVisits from './pages/HomeVisits';
import Conditions from './pages/Conditions';
import OurTeam from './pages/OurTeam';
import Equipment from './pages/Equipment';
import Contact from './pages/Contact';
import OrthopaedicService from './pages/services/OrthopaedicService';
import SportsInjuryService from './pages/services/SportsInjuryService';
import NeurologicalService from './pages/services/NeurologicalService';
import PostSurgicalService from './pages/services/PostSurgicalService';
import BackNeckService from './pages/services/BackNeckService';
import PaediatricService from './pages/services/PaediatricService';
import GeriatricService from './pages/services/GeriatricService';
import HomeVisitService from './pages/services/HomeVisitService';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="services" element={<Services />} />
            <Route path="services/orthopaedic" element={<OrthopaedicService />} />
            <Route path="services/sports-injury" element={<SportsInjuryService />} />
            <Route path="services/neurological" element={<NeurologicalService />} />
            <Route path="services/post-surgical" element={<PostSurgicalService />} />
            <Route path="services/back-neck-pain" element={<BackNeckService />} />
            <Route path="services/paediatric" element={<PaediatricService />} />
            <Route path="services/geriatric" element={<GeriatricService />} />
            <Route path="services/home-visit" element={<HomeVisitService />} />
            <Route path="home-visit-physiotherapy-panjim" element={<HomeVisits />} />
            <Route path="conditions" element={<Conditions />} />
            <Route path="our-team" element={<OurTeam />} />
            <Route path="equipment" element={<Equipment />} />
            <Route path="contact" element={<Contact />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;